import { apiUc } from '../../../../../http/index';

class CallHistoryService {
  async getHistoryByRamal(ramal, limit = 20, offset = 0) {
    return apiUc.get(
      `/api/call-history/${ramal}?limit=${limit}&offset=${offset}`
    );
  }
}

export default new CallHistoryService();
